module.exports = __webpack_public_path__ + "img/Bild 12 Vitra-Corpform-1 Entry WAZ.c5987112.jpg";